import { Divider } from "@fluentui/react-components";
import { Label, TextStyle } from "@lannister/duplo";

import { ReactComponent as PCILogo } from "../../assets/images/PCI-Logo.svg";
import { ReactComponent as SahlLogo } from "../../assets/images/Sahl-Logo.svg";

const PoweredBy = () => {
    return (
        <div style={styles.row}>
            <div style={styles.sahl}>
                <Label labelText="Powered by" textStyle={TextStyle.BaseRegular} />
                <SahlLogo />
            </div>
            <div style={{ maxWidth: "fitContent" }}>
                <Divider vertical />
            </div>
            <PCILogo />
        </div>
    );
}

const styles = {
  row: {
    display: "flex",
    padding: "12px 0 0 0",
    justifyContent: "center",
    alignItems: "center",
    gap: "32px",
    alignSelf: "stretch",
  },
  sahl: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    gap: "8px",
    flexWrap: "wrap",
  }
};

export default PoweredBy;
